import '../../tables/Table.module.css'
import classes from '../../tables/Table.module.css'
import SimilarityRangeTableEditor from './SimilarityRangeTableEditor'

function PlannerSettingsValidationTable(props) {

    const colNames =  ['invalid field', 'validation error', 'please correct'];   
    let tableHead = (
        <>
            <tr style={{fontSize: '14px'}}>
                {colNames.map((columnName, index) => (<th key={index} >{columnName}</th>))}
            </tr>
        </>);

    let input_strategy = (<>
                        <select name='strategy'
                            className={classes.selectDefault}
                            id={`strategy_${props.cycle_id}`} 
                            onChange={props.handleStrategy}>
                                <option value='' disabled selected>{'select strategy'}</option>
                                {props.supportedStrategies.map((option, index) => {
                                    if(option === 'AI-Agent' && !props.AIAgentEnabled ){
                                        return (<option key={index} value={option} disabled>
                                            {option}
                                        </option>)
                                    }
                                    else{
                                        return (<option key={index} value={option}>
                                                    {option}
                                                </option>)
                                    }
                                })}
                    </select>
                    </>);

    let input_batch_size = (<>
                    <input 
                        id={`batch_size`}
                        type='text'  
                        pattern='[0-9]+'
                        placeholder='enter' 
                        autoComplete='false' 
                        onChange={props.handleBatchSize}
                        style={{fontSize: '14px', margin:'0px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>
                    </>);

    let similarity_range = (<>
                        <div style={{marginRight:'10px', marginBottom:'5px'}}>
                            <SimilarityRangeTableEditor 
                                similarity_range={props.similarity_range}
                                factors={props.factors}
                                inputHandler={props.handleInputSimilarityRange}/>
                        </div>
                    </>);


    let tableRows = (<></>);
    tableRows = props.validations.map((validation, id) => {
        let correct = (<></>);
        if (validation.field === 'Strategy'){
            correct = input_strategy; 
        }

        if (validation.field === 'Batch Size'){
            correct = input_batch_size;
        }

        if (validation.field === 'Similarity Range'){
            correct = similarity_range;
        }

        return (<>
            <tr key={`row_${id}`}>
                <td key={`field_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px', marginTop:'5px'}}>
                        {validation.field}
                    </div>
                </td>
                <td key={`validation_error_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px', color:'red', marginTop:'5px'}}>
                        {validation.validation_error.map((msg, idx) => (<div key={idx}>{msg}</div> ))}
                    </div>
                </td>
                <td key={`range_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px', marginTop:'5px'}}>
                        {correct}
                    </div>
                </td>
            </tr>
        </>);
    });





    return(<>
        <table style={{ tableLayout: 'auto' }}>
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={colNames.length}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableRows}
            </tbody>
        </table>
    </>
    );

}


export default PlannerSettingsValidationTable;
